import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    gridContainer: {
        marginTop: '1rem',
        height: '100%'
    },
    dateRangeSelectorLabel: {
        fontSize: '.8rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073'
    },
    toolbarContainer: { padding: '0 1rem' },
    filterOption: {
        padding: '.3rem .75rem',
        fontSize: '.8rem',
        textTransform: 'uppercase' as const,
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        cursor: 'pointer' as const,
        borderRight: '1px solid #d3d3d3',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
                '#bec6d470'
        }
    },
    selectedFilterOption: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        color: theme?.app?.applicationColors.enumColors.white ||
            '#FFFFFF',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColor ||
                '#375073'
        }
    },
    clearFiltersButton: {
        padding: '.3rem',
        fontSize: '.8rem',
        fontWeight: 'bold' as const,
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        marginLeft: '.75rem',
        cursor: 'pointer' as const,
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
                '#bec6d470'
        }
    },
    pageSelectorContainer: { paddingBottom: '.5rem' },
    exportButton: {
        marginTop: '1rem',
        marginLeft: '1rem'
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    }
});